import React from "react"
import { Flex, Box } from "rebass"
import { Footer, SEO, Layout, Container, Hero } from "@components"
import StepColumn from "../components/pages/feature/stepColumn"
import Summary from "../components/pages/feature/summary"
import { ExternalLink } from "@fragments"
import { download } from "@constants/urls.js"
import FAQ from "@components/FAQ"

const productFeaturePage = ({
  pageContext: {
    title,
    metaTitle,
    metaDescription,
    videoPath,
    youtubeId,
    steps,
    summaryTitle,
    summaryDescription,
    faq,
    intro,
    content,
    slug,
    noIndex,
  },
}) => {
  return (
    <>
      <Layout hidePreheaderCTA>
        <SEO
          title={metaTitle || title}
          description={metaDescription}
          canonical={`https://dynobase.dev/${slug}/`}
          noIndex={noIndex}
        />
        <div
          style={{
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Hero title={title} />
          <Container>
            <Box width={1} p={4} backgroundColor={"#f8f8f8"} mt={3}>
              <b>Prerequisite:</b> &nbsp;{" "}
              <ExternalLink to={download} className="dynobase-download-button">
                Download Dynobase
              </ExternalLink>{" "}
              (free to try) in order to follow the steps below
            </Box>
            {intro && (
              <div
                style={{ marginTop: "32px", fontSize: "16px" }}
                dangerouslySetInnerHTML={{ __html: intro }}
              />
            )}
            {youtubeId ? (
              <iframe
                width="100%"
                height="500"
                src={`https://www.youtube.com/embed/${youtubeId}`}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            ) : (
              <video
                autoplay
                loop
                muted
                controls
                style={{
                  boxShadow: "3px 4px 13px 5px hsla(0, 0%, 0%, 0.24)",
                  borderRadius: "4px",
                  width: "100%",
                  marginTop: "44px",
                  marginBottom: "44px",
                }}
              >
                <source src={videoPath} type="video/mp4" />
              </video>
            )}
            <Flex flexWrap="wrap">
              {steps.map((step, index) => (
                <StepColumn
                  title={step.title}
                  description={step.description}
                  stepNumber={index + 1}
                  totalSteps={steps.length}
                />
              ))}
            </Flex>
            {faq && <hr style={{ margin: "20px 40%" }} />}
            {content && (
              <Box my={"40px"}>
                <h2>{content.headline}</h2>
                <p>{content.content}</p>
              </Box>
            )}
            <FAQ questions={faq} mt={"40px"} />
            {summaryDescription && (
              <Summary title={summaryTitle} description={summaryDescription} />
            )}
          </Container>
          <Footer />
        </div>
      </Layout>
    </>
  )
}

export default productFeaturePage
